import React from 'react';
import { Typography } from '@mui/material';

const Analytics: React.FC = () => {
  return <Typography>Analytics & ROI Dashboard - coming soon</Typography>;
};

export default Analytics;
